import {
  Box,
  Button,
  Card,
  Checkbox,
  IconButton,
  InputAdornment,
  MenuItem,
  Stack,
  TextField,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import AdornedInput from "../../../../../components/AdornedInput";
import TextFieldDebouncedNoInitialLoad from "../../../../../components/TextFieldDebouncedNoInitialLoad";
import {
  currencyFormatNoDecimals,
  toThreeDecimals,
  toTwoDecimals,
} from "../../../../../components/NewDetail/calculations/utils";
import { useTheme } from "@emotion/react";
import usePanelSystems from "../../../../../hooks/usePanelSystems";
import calculatePanelCut from "../../../../../components/NewDetail/calculations/panelCut";
import { Close } from "@mui/icons-material";
import AddPanelForm from "./AddPanelForm";
import AdornedInputDebouncedNoInitialLoad from "../../../../../components/AdornedInputDebouncedNoInitialLoad";

const Panel = ({ isTollForm, coilCostPerSqFt, panel, onUpdatePanel }) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const isMediumScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [showCutForm, setShowCutForm] = useState(false);

  const { panelSystems, getPanelSystems, refreshing } = usePanelSystems();
  const [widthOptions, setWidthOptions] = useState([]);
  const initCut = { name: "", quantity: "", feet: "", inches: "" };
  const [newCut, setNewCut] = useState(initCut);
  const [showPanelForm, setShowPanelForm] = useState(false);
  const toggleForm = () => {
    setNewCut(initCut);
    setShowPanelForm(!showPanelForm);
  };
  const handleChangeNewCutChange = (fieldName) => (e) => {
    let val = e.target.value;
    if (fieldName == "quantity" || fieldName == "feet") {
      val = Math.round(val);
    }
    if (fieldName == "inches") {
      val = toThreeDecimals(val);
      if (val < 0) val = 0;
      // if (val >= 12) val = 0;
    }
    setNewCut((curr) => ({ ...curr, [fieldName]: val }));
  };

  // New
  const getPanelSystemIndexByName = (panelSystemDescription) => {
    let i;
    for (i = 0; i < panelSystems.length; i++) {
      let system = panelSystems[i];
      if (system.description === panelSystemDescription) return i;
    }
    return 0;
  };

  const getTypeOptions = (panelSystemDescription) => {
    return panelSystems.find(
      (system) => system.description === panelSystemDescription
    ).panelTypes;
  };

  const getWidthOptions = (panelSystemDescription, panelTypeDescription) => {
    let panelTypes = getTypeOptions(panelSystemDescription);
    let i;
    for (i = 0; i < panelTypes.length; i++) {
      let panelType = panelTypes[i];
      if (panelType.description === panelTypeDescription)
        return panelType.panelWidths;
    }
  };

  const handleSystemSelect = (systemIndex) => {
    const system = panelSystems[systemIndex];
    // const defaultPanelType = system.panelTypes[0];
    // panelWidths is an array of strings
    // let defaultPanelWidth = Number(defaultPanelType.panelWidths[0]);

    // IF "Flush Wall, SL-175, Striated With Clip Relief" then default Panel Width to 18
    // if (defaultPanelType.description == "SL-175, Striated With Clip Relief") {
    //   if (defaultPanelType.panelWidths.includes("18")) defaultPanelWidth = 18;
    // }

    // onUpdatePanel({
    //   ...panel,
    //   panelSystem: system.description,
    //   panelType: defaultPanelType.description,
    //   panelTakeUp: defaultPanelType.panelTakeUp,
    //   panelWidth: defaultPanelWidth,
    //   profile: "",
    // });
    onUpdatePanel({
      ...panel,
      panelSystem: system.description,
      panelType: null,
      panelTakeUp: null,
      panelWidth: null,
      profile: "",
    });
  };

  const handleTypeSelect = (panelSystem, systemType) => {
    // // Use reducer to update default width selected
    // let widthOptions = getWidthOptions(panelSystem, systemType);
    // console.log("width options", widthOptions);
    let typeOptions = getTypeOptions(panelSystem);
    let selectePaneltype = typeOptions.find((t) => t.description == systemType);

    // let defaultPanelWidth = Number(widthOptions[0]);
    // IF "Flush Wall, SL-175, Striated With Clip Relief" then default Panel Width to 18
    // if (systemType == "SL-175, Striated With Clip Relief") {
    //   if (widthOptions.includes("18")) defaultPanelWidth = 18;
    // }

    // onUpdatePanel({
    //   ...panel,
    //   panelType: systemType,
    //   panelTakeUp: selectePaneltype.panelTakeUp,
    //   panelWidth: defaultPanelWidth,
    // });
    onUpdatePanel({
      ...panel,
      panelType: systemType,
      panelTakeUp: selectePaneltype.panelTakeUp,
      panelWidth: null,
    });
  };

  const handlePanelWidthSelect = (panelWidth) => {
    onUpdatePanel({
      ...panel,
      panelWidth: panelWidth,
    });
  };

  const handleAddPanelCut = (cut) => {
    let cutsCopy = [...panel.cuts];
    cutsCopy.push(cut);

    onUpdatePanel({ ...panel, cuts: cutsCopy });
  };

  const handleRemovePanelCut = (cutIndex) => {
    let cutsCopy = [...panel.cuts];
    cutsCopy.splice(cutIndex, 1);

    onUpdatePanel({ ...panel, cuts: cutsCopy });
  };

  useEffect(() => {
    // Once panel systems are loaded...
    if (panelSystems.length > 0) {
    }
  }, [panelSystems]);

  if (panelSystems.length == 0) return null;

  return (
    <Box>
      <Typography sx={{ flex: 1 }} variant="h6">
        Panel
        {panel.totalSellPrice !== undefined && panel.totalSellPrice !== null
          ? ` - ${currencyFormatNoDecimals(
              Math.round(Number(panel.totalSellPrice ?? 0))
            )}`
          : ""}
      </Typography>
      <Box sx={{}}>
        <Box
          sx={{
            display: "flex",
            flexDirection: isMediumScreen ? "column" : "row",
          }}
        >
          <Box sx={{}}>
            {/* <Typography>
              Square Foot Pricing: $
              {coilCostPerSqFt ? parseFloat(coilCostPerSqFt) : 0}
            </Typography> */}
            <Box
              sx={{ marginTop: "8px", display: "flex", flexDirection: "row" }}
            >
              <TextField
                sx={{ width: "200px" }}
                select
                variant="outlined"
                label="Panel System"
                id="system"
                name="Panel System"
                size="small"
                fullWidth
                value={
                  panel.panelSystem
                    ? getPanelSystemIndexByName(panel.panelSystem)
                    : null
                }
                onChange={(e) => handleSystemSelect(e.target.value)}
              >
                {panelSystems &&
                  panelSystems?.map((sys, index) => (
                    <MenuItem key={sys.description} value={index}>
                      {sys.description}
                    </MenuItem>
                  ))}
              </TextField>
              <TextField
                sx={{ width: "300px", marginLeft: "8px" }}
                select
                variant="outlined"
                label="Panel Type"
                id="type"
                name="Panel Type"
                size="small"
                fullWidth
                value={panel.panelType}
                onChange={(e) => {
                  handleTypeSelect(panel.panelSystem, e.target.value);
                }}
              >
                {panel.panelSystem &&
                  getTypeOptions(panel.panelSystem).map((type) => (
                    <MenuItem key={type.description} value={type.description}>
                      {type.description}
                    </MenuItem>
                  ))}
              </TextField>
              {panel.panelSystem && panel.panelType && (
                <TextField
                  sx={{ width: "100px", marginLeft: "8px" }}
                  select
                  variant="outlined"
                  label="Panel Width"
                  id="width"
                  name="Panel Width"
                  size="small"
                  fullWidth
                  value={panel.panelWidth}
                  onChange={(e) => {
                    handlePanelWidthSelect(Number(e.target.value));
                    // onUpdatePanel({
                    //   ...panel,
                    //   panelWidth: e.target.value,
                    // });
                  }}
                >
                  {getWidthOptions(panel.panelSystem, panel.panelType).map(
                    (width) => (
                      <MenuItem value={Number(width)} key={width}>
                        {width}
                      </MenuItem>
                    )
                  )}
                </TextField>
              )}
            </Box>
          </Box>
        </Box>
        <Stack direction="column" spacing={2}>
          <Typography>Material & Labor</Typography>
          <Stack direction="column" spacing={2}>
            <Stack direction="row" spacing={2}>
              <AdornedInput
                type="number"
                onWheel={(event) => {
                  event.preventDefault();
                }}
                onFocus={(e) => e.target.select()}
                label="Coil Size Needed"
                value={panel.calculations.coilSizeNeeded}
                // onChange={handleChange("coil_size_needed")}
                // isOveridden={overrides?.coil_size_needed}
                // handleReset={resetOverride("coil_size_needed")}
                inputProps={{ readOnly: true }}
                disabled
              />
              <AdornedInput
                type="number"
                onWheel={(event) => {
                  event.preventDefault();
                }}
                onFocus={(e) => e.target.select()}
                label="Master Coil Size Needed"
                // OLD value={panel.calculations.masterCoilSizeNeeded}
                // onChange={handleChange("master_coil_size_needed")}
                // isOveridden={overrides?.master_coil_size_needed}
                // handleReset={resetOverride("master_coil_size_needed")}

                value={toTwoDecimals(
                  panel.overrides &&
                    panel.overrides.master_coil_size_needed !== null &&
                    panel.overrides.master_coil_size_needed !== undefined
                    ? panel.overrides.master_coil_size_needed
                    : panel.calculations &&
                      panel.calculations.masterCoilSizeNeeded
                    ? panel.calculations.masterCoilSizeNeeded
                    : 0
                )}
                onChange={(e) => {
                  let overrides = {
                    ...panel.overrides,
                    master_coil_size_needed: e.target.value,
                  };
                  onUpdatePanel({
                    ...panel,
                    overrides,
                  });
                }}
                isOveridden={
                  panel.overrides &&
                  panel.overrides.master_coil_size_needed !== null &&
                  panel.overrides.master_coil_size_needed !== undefined
                }
                handleReset={() => {
                  let overrides = {
                    ...panel.overrides,
                    master_coil_size_needed: null,
                  };
                  onUpdatePanel({
                    ...panel,
                    overrides,
                  });
                }}
                // inputProps={{ readOnly: true }}
                // disabled
              />
              <AdornedInput
                type="number"
                onWheel={(event) => {
                  event.preventDefault();
                }}
                onFocus={(e) => e.target.select()}
                label="Coil Drop/Excess"
                value={panel.calculations.coilDrop}
                // onChange={handleChange("coil_drop")}
                // isOveridden={overrides?.coil_drop}
                // handleReset={resetOverride("coil_drop")}
                inputProps={{ readOnly: true }}
                disabled
              />
              <AdornedInput
                type="number"
                onWheel={(event) => {
                  event.preventDefault();
                }}
                onFocus={(e) => e.target.select()}
                label="Coils Cut From Master"
                value={panel.calculations.coilsCutFromMaster}
                // onChange={handleChange("coils_cut_from_master")}
                // isOveridden={overrides?.coils_cut_from_master}
                // handleReset={resetOverride("coils_cut_from_master")}
                inputProps={{ readOnly: true }}
                disabled
              />
            </Stack>
            <Stack direction="row" spacing={2}>
              <TextFieldDebouncedNoInitialLoad
                size="small"
                type="number"
                onWheel={(event) => {
                  event.preventDefault();
                }}
                onFocus={(e) => e.target.select()}
                label="Waste Rate"
                value={panel.calculations.waste}
                // onChange={handleChange("waste")}
                // isOveridden={overrides?.waste}
                // handleReset={resetOverride("waste")}
                onChange={(e) => {
                  // Update variables instead of override
                  let variables = {
                    ...panel.variables,
                    waste: parseFloat(e.target.value),
                  };

                  onUpdatePanel({
                    ...panel,
                    variables: variables,
                  });
                }}
              />
              <AdornedInput
                type="number"
                onWheel={(event) => {
                  event.preventDefault();
                }}
                onFocus={(e) => e.target.select()}
                label="Coil LF (no waste)"
                value={panel.linealFeetOfCoilNoWaste}
                // onChange={handleChange("lineal_feet_of_coil_no_waste")}
                // isOveridden={overrides?.lineal_feet_of_coil_no_waste}
                // handleReset={resetOverride("lineal_feet_of_coil_no_waste")}
                inputProps={{ readOnly: true }}
                disabled
              />
              <AdornedInput
                type="number"
                onWheel={(event) => {
                  event.preventDefault();
                }}
                onFocus={(e) => e.target.select()}
                label="Coil LF (with waste)"
                value={panel.calculations.linealFeetOfCoilWithWaste}
                // onChange={handleChange("lineal_feet_of_coil_with_waste")}
                // isOveridden={overrides?.lineal_feet_of_coil_with_waste}
                // handleReset={resetOverride("lineal_feet_of_coil_with_waste")}
                inputProps={{ readOnly: true }}
                disabled
              />
              <AdornedInput
                type="number"
                onWheel={(event) => {
                  event.preventDefault();
                }}
                onFocus={(e) => e.target.select()}
                label="Coil Sq Ft (with waste)"
                value={panel.calculations.squareFeetOfCoilNeededWithWaste}
                // onChange={handleChange("square_feet_of_coil_needed_with_waste")}
                // isOveridden={overrides?.square_feet_of_coil_needed_with_waste}
                // handleReset={resetOverride(
                //   "square_feet_of_coil_needed_with_waste"
                // )}
                inputProps={{ readOnly: true }}
                disabled
              />
            </Stack>
            <Stack direction="row" spacing={2}>
              <AdornedInput
                type="number"
                onWheel={(event) => {
                  event.preventDefault();
                }}
                onFocus={(e) => e.target.select()}
                label="Finished Panel Sq. Ft."
                value={panel.finishedPanelSquareFeet}
                // onChange={handleChange("finished_panel_square_feet")}
                // isOveridden={overrides?.finished_panel_square_feet}
                // handleReset={resetOverride("finished_panel_square_feet")}
                inputProps={{ readOnly: true }}
                disabled
              />
            </Stack>
          </Stack>

          <Typography>Cost Breakdown</Typography>
          {!isTollForm && (
            <Stack direction="row" spacing={2}>
              <AdornedInputDebouncedNoInitialLoad
                disabled
                type="number"
                onWheel={(event) => {
                  event.preventDefault();
                }}
                onFocus={(e) => e.target.select()}
                label="Usable Coil Cost"
                value={toTwoDecimals(
                  panel.overrides &&
                    panel.overrides.material_cost !== null &&
                    panel.overrides.material_cost !== undefined
                    ? panel.overrides.material_cost
                    : panel.calculations && panel.calculations.materialCost
                    ? panel.calculations.materialCost
                    : 0
                )}
                onChange={(e) => {
                  let overrides = {
                    ...panel.overrides,
                    material_cost: e.target.value,
                  };
                  onUpdatePanel({
                    ...panel,
                    overrides,
                  });
                }}
                isOveridden={
                  panel.overrides &&
                  panel.overrides.material_cost !== null &&
                  panel.overrides.material_cost !== undefined
                }
                handleReset={() => {
                  let overrides = {
                    ...panel.overrides,
                    material_cost: null,
                  };
                  onUpdatePanel({
                    ...panel,
                    overrides,
                  });
                }}
                symbol="$"
                position="start"
              />
              <AdornedInputDebouncedNoInitialLoad
                disabled
                type="number"
                onWheel={(event) => {
                  event.preventDefault();
                }}
                onFocus={(e) => e.target.select()}
                label="Drop Coil Cost"
                value={toTwoDecimals(panel.calculations.panelDropCoilCost ?? 0)}
                symbol="$"
                position="start"
              />
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  magin: 0,
                  padding: 0,
                }}
              >
                <Checkbox
                  style={{
                    magin: 0,
                    padding: 0,
                  }}
                  checked={panel.variables.exclude_panel_drop_from_cost}
                  onChange={(e) => {
                    let variables = {
                      ...panel.variables,
                      exclude_panel_drop_from_cost: e.target.checked,
                      panel_drop_exclusion_reason: "",
                    };
                    onUpdatePanel({
                      ...panel,
                      variables,
                    });
                  }}
                />
                <Typography>Exclude Drop Cost</Typography>
              </Box>
              {panel.variables.exclude_panel_drop_from_cost && (
                <TextFieldDebouncedNoInitialLoad
                  sx={{ width: "400px" }}
                  size="small"
                  variant="outlined"
                  required={panel.variables.exclude_panel_drop_from_cost}
                  disabled={!panel.variables.exclude_panel_drop_from_cost}
                  onWheel={(event) => {
                    event.preventDefault();
                  }}
                  onFocus={(e) => e.target.select()}
                  label="Exclude Drop Cost Reason"
                  value={panel.variables.panel_drop_exclusion_reason}
                  onChange={(e) => {
                    let variables = {
                      ...panel.variables,
                      panel_drop_exclusion_reason: e.target.value,
                    };
                    onUpdatePanel({
                      ...panel,
                      variables,
                    });
                  }}
                />
              )}
              {/* <AdornedInputDebouncedNoInitialLoad
              disabled
              type="number"
              onWheel={(event) => {
                event.preventDefault();
              }}
              onFocus={(e) => e.target.select()}
              label="Total Material Cost"
              value={toTwoDecimals(
                panel.overrides &&
                  panel.overrides.material_cost !== null &&
                  panel.overrides.material_cost !== undefined
                  ? panel.overrides.material_cost
                  : panel.calculations && panel.calculations.materialCost
                  ? panel.calculations.materialCost
                  : 0
              )}
              onChange={(e) => {
                let overrides = {
                  ...panel.overrides,
                  material_cost: e.target.value,
                };
                onUpdatePanel({
                  ...panel,
                  overrides,
                });
              }}
              isOveridden={
                panel.overrides &&
                panel.overrides.material_cost !== null &&
                panel.overrides.material_cost !== undefined
              }
              handleReset={() => {
                let overrides = {
                  ...panel.overrides,
                  material_cost: null,
                };
                onUpdatePanel({
                  ...panel,
                  overrides,
                });
              }}
              symbol="$"
              position="start"
            /> */}
            </Stack>
          )}

          <Stack direction="row" spacing={2}>
            {!isTollForm && (
              <AdornedInputDebouncedNoInitialLoad
                disabled
                type="number"
                onWheel={(event) => {
                  event.preventDefault();
                }}
                onFocus={(e) => e.target.select()}
                label="Total Coil Cost"
                value={toTwoDecimals(
                  panel.overrides &&
                    panel.overrides.material_cost !== null &&
                    panel.overrides.material_cost !== undefined
                    ? panel.overrides.material_cost
                    : panel.calculations && panel.calculations.materialCost
                    ? panel.calculations.materialCost
                    : 0
                )}
                onChange={(e) => {
                  let overrides = {
                    ...panel.overrides,
                    material_cost: e.target.value,
                  };
                  onUpdatePanel({
                    ...panel,
                    overrides,
                  });
                }}
                isOveridden={
                  panel.overrides &&
                  panel.overrides.material_cost !== null &&
                  panel.overrides.material_cost !== undefined
                }
                handleReset={() => {
                  let overrides = {
                    ...panel.overrides,
                    material_cost: null,
                  };
                  onUpdatePanel({
                    ...panel,
                    overrides,
                  });
                }}
                symbol="$"
                position="start"
              />
            )}

            <AdornedInputDebouncedNoInitialLoad
              type="number"
              onWheel={(event) => {
                event.preventDefault();
              }}
              onFocus={(e) => e.target.select()}
              label="Est. Man Hours"
              value={toTwoDecimals(
                panel.overrides &&
                  panel.overrides.total_estimated_labor_hours !== null &&
                  panel.overrides.total_estimated_labor_hours !== undefined
                  ? panel.overrides.total_estimated_labor_hours
                  : panel.calculations && panel.calculations.estimatedLaborHours
                  ? panel.calculations.estimatedLaborHours
                  : 0
              )}
              onChange={(e) => {
                let overrides = {
                  ...panel.overrides,
                  total_estimated_labor_hours: e.target.value,
                };
                onUpdatePanel({
                  ...panel,
                  overrides,
                });
              }}
              isOveridden={
                panel.overrides &&
                panel.overrides.total_estimated_labor_hours !== null &&
                panel.overrides.total_estimated_labor_hours !== undefined
              }
              handleReset={() => {
                let overrides = {
                  ...panel.overrides,
                  total_estimated_labor_hours: null,
                };
                onUpdatePanel({
                  ...panel,
                  overrides,
                });
              }}
            />
            {!isTollForm && (
              <AdornedInputDebouncedNoInitialLoad
                disabled
                type="number"
                onWheel={(event) => {
                  event.preventDefault();
                }}
                onFocus={(e) => e.target.select()}
                label="Est. Labor Cost"
                value={toTwoDecimals(
                  panel.overrides &&
                    panel.overrides.total_estimated_labor_cost !== null &&
                    panel.overrides.total_estimated_labor_cost !== undefined
                    ? panel.overrides.total_estimated_labor_cost
                    : panel.calculations &&
                      panel.calculations.estimatedLaborCost
                    ? panel.calculations.estimatedLaborCost
                    : 0
                )}
                onChange={(e) => {
                  let overrides = {
                    ...panel.overrides,
                    total_estimated_labor_cost: e.target.value,
                  };
                  onUpdatePanel({
                    ...panel,
                    overrides,
                  });
                }}
                isOveridden={
                  panel.overrides &&
                  panel.overrides.total_estimated_labor_cost !== null &&
                  panel.overrides.total_estimated_labor_cost !== undefined
                }
                handleReset={() => {
                  let overrides = {
                    ...panel.overrides,
                    total_estimated_labor_cost: null,
                  };
                  onUpdatePanel({
                    ...panel,
                    overrides,
                  });
                }}
                symbol="$"
                position="start"
              />
            )}
            {!isTollForm && (
              <AdornedInputDebouncedNoInitialLoad
                type="number"
                onWheel={(event) => {
                  event.preventDefault();
                }}
                onFocus={(e) => e.target.select()}
                label="Est. Lumber Cost"
                value={toTwoDecimals(
                  panel.overrides &&
                    panel.overrides.estimated_lumber_cost !== null &&
                    panel.overrides.estimated_lumber_cost !== undefined
                    ? panel.overrides.estimated_lumber_cost
                    : panel.calculations &&
                      panel.calculations.estimatedLumberCost
                    ? panel.calculations.estimatedLumberCost
                    : 0
                )}
                onChange={(e) => {
                  let overrides = {
                    ...panel.overrides,
                    estimated_lumber_cost: e.target.value,
                  };
                  onUpdatePanel({
                    ...panel,
                    overrides,
                  });
                }}
                isOveridden={
                  panel.overrides &&
                  panel.overrides.estimated_lumber_cost !== null &&
                  panel.overrides.estimated_lumber_cost !== undefined
                }
                handleReset={() => {
                  let overrides = {
                    ...panel.overrides,
                    estimated_lumber_cost: null,
                  };
                  onUpdatePanel({
                    ...panel,
                    overrides,
                  });
                }}
                symbol="$"
                position="start"
              />
            )}
          </Stack>
          {!isTollForm && (
            <Stack direction="row" spacing={2}>
              <AdornedInputDebouncedNoInitialLoad
                disabled
                type="number"
                onWheel={(event) => {
                  event.preventDefault();
                }}
                onFocus={(e) => e.target.select()}
                label="Total Hard Cost"
                value={toTwoDecimals(
                  panel.overrides &&
                    panel.overrides.total_hard_cost !== null &&
                    panel.overrides.total_hard_cost !== undefined
                    ? panel.overrides.total_hard_cost
                    : panel.calculations && panel.calculations.totalHardCost
                    ? panel.calculations.totalHardCost
                    : 0
                )}
                onChange={(e) => {
                  let overrides = {
                    ...panel.overrides,
                    total_hard_cost: e.target.value,
                  };
                  onUpdatePanel({
                    ...panel,
                    overrides,
                  });
                }}
                isOveridden={
                  panel.overrides &&
                  panel.overrides.total_hard_cost !== null &&
                  panel.overrides.total_hard_cost !== undefined
                }
                handleReset={() => {
                  let overrides = {
                    ...panel.overrides,
                    total_hard_cost: null,
                  };
                  onUpdatePanel({
                    ...panel,
                    overrides,
                  });
                }}
                symbol="$"
                position="start"
              />
            </Stack>
          )}

          <Stack direction="row" spacing={2}>
            {!isTollForm && (
              <TextFieldDebouncedNoInitialLoad
                // disabled
                size="small"
                type="number"
                onWheel={(event) => {
                  event.preventDefault();
                }}
                onFocus={(e) => e.target.select()}
                label="Default GP %"
                value={
                  panel.variables.gross_profit_margin
                    ? toTwoDecimals(panel.variables.gross_profit_margin * 100)
                    : 0
                }
                onChange={(e) => {
                  // Update variables instead of override
                  let variables = {
                    ...panel.variables,
                    gross_profit_margin: parseFloat(
                      parseFloat(e.target.value).toFixed(4) / 100.0
                    ).toFixed(4),
                  };

                  onUpdatePanel({
                    ...panel,
                    variables: variables,
                  });
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end" sx={{ marginLeft: "4px" }}>
                      %
                    </InputAdornment>
                  ),
                }}
              />
            )}
            {!isTollForm && (
              <AdornedInputDebouncedNoInitialLoad
                disabled
                type="number"
                onWheel={(event) => {
                  event.preventDefault();
                }}
                onFocus={(e) => e.target.select()}
                label="Gross Profit (Default GP %)"
                value={
                  panel.overrides &&
                  panel.overrides.gross_profit_dollars !== null &&
                  panel.overrides.gross_profit_dollars !== undefined
                    ? panel.overrides.gross_profit_dollars
                    : panel.calculations &&
                      panel.calculations.grossProfitDollars
                    ? panel.calculations.grossProfitDollars
                    : 0
                }
                onChange={(e) => {
                  let overrides = {
                    ...panel.overrides,
                    gross_profit_dollars: e.target.value,
                  };
                  onUpdatePanel({
                    ...panel,
                    overrides,
                  });
                }}
                isOveridden={
                  panel.overrides &&
                  panel.overrides.gross_profit_dollars !== null &&
                  panel.overrides.gross_profit_dollars !== undefined
                }
                handleReset={() => {
                  let overrides = {
                    ...panel.overrides,
                    gross_profit_dollars: null,
                  };
                  onUpdatePanel({
                    ...panel,
                    overrides,
                  });
                }}
                symbol="$"
                position="start"
              />
            )}

            <TextField
              disabled
              size="small"
              type="number"
              label="Suggested Sale Price"
              value={
                panel && panel.calculations && panel.totalSellPrice
                  ? panel.calculations.totalSellPrice
                  : 0
              }
            />
            <TextField
              disabled
              type="number"
              size="small"
              label="Suggested Panel Price/Sq. Ft."
              value={
                panel.calculations && panel.calculations.panelPricePerSquareFoot
                  ? panel.calculations.panelPricePerSquareFoot
                  : 0
              }
            />
          </Stack>

          <Stack direction="row" spacing={2}>
            {!isTollForm && (
              <TextFieldDebouncedNoInitialLoad
                disabled
                size="small"
                type="number"
                onWheel={(event) => {
                  event.preventDefault();
                }}
                onFocus={(e) => e.target.select()}
                label="Actual GP %"
                value={
                  panel.calculations.actualGrossProfitMargin
                    ? toTwoDecimals(
                        panel.calculations.actualGrossProfitMargin * 100
                      )
                    : 0
                }
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end" sx={{ marginLeft: "4px" }}>
                      %
                    </InputAdornment>
                  ),
                }}
              />
            )}
            {!isTollForm && (
              <AdornedInputDebouncedNoInitialLoad
                disabled
                type="number"
                onWheel={(event) => {
                  event.preventDefault();
                }}
                onFocus={(e) => e.target.select()}
                label="Actual Gross Profit"
                value={
                  panel.calculations &&
                  panel.calculations.actualGrossProfitDollars
                    ? panel.calculations.actualGrossProfitDollars
                    : 0
                }
                symbol="$"
                position="start"
              />
            )}

            <AdornedInputDebouncedNoInitialLoad
              type="number"
              onWheel={(event) => {
                event.preventDefault();
              }}
              onFocus={(e) => e.target.select()}
              label="Final Sale Price"
              value={panel && panel.totalSellPrice ? panel.totalSellPrice : 0}
              onChange={(e) => {
                let overrides = {
                  ...panel.overrides,
                  total_sell_price: e.target.value,
                  panel_price_per_square_foot: null,
                };
                onUpdatePanel({
                  ...panel,
                  overrides,
                });
              }}
              isOveridden={
                (panel.overrides &&
                  panel.overrides.total_sell_price !== null &&
                  panel.overrides.total_sell_price !== undefined) ||
                (panel.overrides &&
                  panel.overrides.panel_price_per_square_foot !== null &&
                  panel.overrides.panel_price_per_square_foot !== undefined)
              }
              handleReset={() => {
                let overrides = {
                  ...panel.overrides,
                  total_sell_price: null,
                  panel_price_per_square_foot: null,
                };
                onUpdatePanel({
                  ...panel,
                  overrides,
                });
              }}
              symbol="$"
              position="start"
            />
            <AdornedInputDebouncedNoInitialLoad
              type="number"
              onWheel={(event) => {
                event.preventDefault();
              }}
              onFocus={(e) => e.target.select()}
              label="Final Panel Price/Sq. Ft."
              value={
                panel && panel.panelPricePerSquareFoot
                  ? panel.panelPricePerSquareFoot
                  : 0
              }
              onChange={(e) => {
                let overrides = {
                  ...panel.overrides,
                  panel_price_per_square_foot: e.target.value,
                  total_sell_price: null,
                };
                onUpdatePanel({
                  ...panel,
                  overrides,
                });
              }}
              isOveridden={
                (panel.overrides &&
                  panel.overrides.total_sell_price !== null &&
                  panel.overrides.total_sell_price !== undefined) ||
                (panel.overrides &&
                  panel.overrides.panel_price_per_square_foot !== null &&
                  panel.overrides.panel_price_per_square_foot !== undefined)
              }
              handleReset={() => {
                let overrides = {
                  ...panel.overrides,
                  panel_price_per_square_foot: null,
                  total_sell_price: null,
                };
                onUpdatePanel({
                  ...panel,
                  overrides,
                });
              }}
              symbol="$"
              position="start"
            />
          </Stack>
        </Stack>
        <Box>
          <Box sx={{ display: "flex", flexDirection: "row", gap: ".5rem" }}>
            <Typography variant="overline">Cut List:</Typography>
            {!showCutForm && (
              <Button
                size="small"
                variant="text"
                onClick={() => {
                  setShowCutForm(true);
                }}
              >
                + Add
              </Button>
            )}
          </Box>
          {showCutForm && (
            <AddPanelForm
              onSubmit={(cut) => {
                // TODO
                handleAddPanelCut(cut);
                setShowCutForm(false);
              }}
              onClose={() => {
                setShowCutForm(false);
              }}
            />
          )}
          {panel.cuts.map((cut, index) => {
            // TODO: transfer this logic to QuoteForm.calculatePanel?
            let panelCutCalculations = calculatePanelCut(
              cut,
              panel,
              panel.calculations,
              panel.calculations,
              panel.overrides
            );
            return (
              <Box
                key={cut.name + index}
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  padding: ".5rem",
                  border: "1px solid #E0E0E0",
                  borderRadius: ".5rem",
                }}
              >
                <TextFieldDebouncedNoInitialLoad
                  variant="standard"
                  size="small"
                  label="Name"
                  value={cut.name}
                  onFocus={(e) => e.target.select()}
                  onChange={(e) => {
                    // action({
                    //   type: "UPDATE PANEL: EDIT CUT",
                    //   payload: {
                    //     index: index,
                    //     update: {
                    //       name: e.target.value,
                    //     },
                    //   },
                    // })
                    let cutsCopy = [...panel.cuts];
                    cutsCopy[index].name = e.target.value;
                    onUpdatePanel({ ...panel, cuts: cutsCopy });
                  }}
                />
                <TextFieldDebouncedNoInitialLoad
                  sx={{ marginLeft: "8px" }}
                  type="number"
                  onWheel={(event) => {
                    event.preventDefault();
                  }}
                  variant="standard"
                  size="small"
                  label="Quantity"
                  value={cut.quantity}
                  onFocus={(e) => e.target.select()}
                  onChange={(e) => {
                    //  action({
                    //   type: "UPDATE PANEL: EDIT CUT",
                    //   payload: {
                    //     index: index,
                    //     update: {
                    //       quantity: e.target.value,
                    //     },
                    //   },
                    // })
                    let cutsCopy = [...panel.cuts];
                    cutsCopy[index].quantity = e.target.value;
                    onUpdatePanel({ ...panel, cuts: cutsCopy });
                  }}
                />
                <TextFieldDebouncedNoInitialLoad
                  sx={{ marginLeft: "8px" }}
                  type="number"
                  onWheel={(event) => {
                    event.preventDefault();
                  }}
                  variant="standard"
                  size="small"
                  label="Feet"
                  value={cut.feet}
                  onFocus={(e) => e.target.select()}
                  onChange={(e) => {
                    // action({
                    //   type: "UPDATE PANEL: EDIT CUT",
                    //   payload: {
                    //     index: index,
                    //     update: {
                    //       feet: e.target.value,
                    //     },
                    //   },
                    // });
                    let cutsCopy = [...panel.cuts];
                    cutsCopy[index].feet = e.target.value;
                    onUpdatePanel({ ...panel, cuts: cutsCopy });
                  }}
                />
                <TextFieldDebouncedNoInitialLoad
                  sx={{ marginLeft: "8px" }}
                  type="number"
                  onWheel={(event) => {
                    event.preventDefault();
                  }}
                  variant="standard"
                  size="small"
                  label="Inches"
                  value={cut.inches}
                  onFocus={(e) => e.target.select()}
                  onChange={(e) => {
                    // action({
                    //   type: "UPDATE PANEL: EDIT CUT",
                    //   payload: {
                    //     index: index,
                    //     update: {
                    //       inches: e.target.value,
                    //     },
                    //   },
                    // })
                    let cutsCopy = [...panel.cuts];
                    cutsCopy[index].inches = e.target.value;
                    onUpdatePanel({ ...panel, cuts: cutsCopy });
                  }}
                />
                <TextFieldDebouncedNoInitialLoad
                  sx={{ marginLeft: "8px" }}
                  type="number"
                  onWheel={(event) => {
                    event.preventDefault();
                  }}
                  variant="standard"
                  size="small"
                  label="LF Coil (no Waste)"
                  value={panelCutCalculations.linealFeetOfCoilNoWaste}
                  InputProps={{
                    readOnly: true,
                    disableUnderline: true,
                  }}
                />
                <TextFieldDebouncedNoInitialLoad
                  type="number"
                  onWheel={(event) => {
                    event.preventDefault();
                  }}
                  variant="standard"
                  size="small"
                  label="Finished Panel Sq Ft"
                  value={panelCutCalculations.finishedPanelSquareFeet}
                  InputProps={{
                    readOnly: true,
                    disableUnderline: true,
                  }}
                />
                <Tooltip title="Remove">
                  <IconButton
                    size="small"
                    onClick={() => {
                      handleRemovePanelCut(index);
                    }}
                  >
                    <Close fontSize="inherit" />
                  </IconButton>
                </Tooltip>
              </Box>
            );
          })}
        </Box>
      </Box>
    </Box>
  );
};

export default Panel;
